import React from 'react';
import Home from './sections/Home';

import { getTheme } from './utils';
import Presentation from './sections/Presentation';
import Footer from './sections/Footer';
import Members from './sections/Members';
import Reports from './sections/Reports';

function App() {
	
	const [x, y] = React.useState(false);
	window.addEventListener("render", () => {
		y(!x);
	});

    return <div className={"theme theme--" + getTheme()}>
		<Home/>
		<Presentation/>
		<Members/>
		<Reports/>
		<Footer/>
	</div>;
}

export default App;
